module.exports = __webpack_public_path__ + "static/media/shop-direction.5b788824.svg";